export default "__VITE_ASSET__n9d8Mqe9__"